import { atom } from 'jotai';
import type { ColorByRule } from 'components/color-by-attribute-modal';

/**
 * Colour rules for the wells on a surface, held per host.
 *
 * An atom because the rail writes the rules and the cards read them, and the two are
 * siblings. Two atoms rather than one so a well page's rules never paint a workspace's
 * surfaces, or the reverse. Session state; nothing is persisted yet.
 */
export const wellPageColorRulesAtom = atom<ColorByRule[]>([]);
export const workspaceColorRulesAtom = atom<ColorByRule[]>([]);
